import CollectionsList from './CollectionsList';

export default CollectionsList;
